import React, { useEffect, useState } from "react";
import { BiChevronLeft, BiHomeAlt2, BiUser } from "react-icons/bi";
import { FaLanguage } from "react-icons/fa";
import { MdSubject } from "react-icons/md";
import { SlGraduation, SlWrench } from "react-icons/sl";
import {
  FaIndustry,
  FaUserTie,
  FaLevelUpAlt,
  FaRegMoneyBillAlt,
  FaUsers,
} from "react-icons/fa";
import {
  AiOutlinePieChart,
  AiOutlineAreaChart,
  AiOutlineFileText,
  AiOutlineLineChart,
  AiOutlineCamera,
} from "react-icons/ai";
import {
  BsGraphUpArrow,
  BsBank,
  BsGenderAmbiguous,
  BsBriefcase,
  BsBuildings,
  BsCurrencyExchange,
} from "react-icons/bs";

import { Link, NavLink } from "react-router-dom";

import { SiGoogletranslate } from "react-icons/si";
import { CiUser } from "react-icons/ci";
import { RxQuestionMarkCircled } from "react-icons/rx";
import { GoGlobe } from "react-icons/go";
import { FaLocationDot } from "react-icons/fa6";
import { FcPositiveDynamic } from "react-icons/fc";
import { getProfileApi } from "../../apifile/ApiFiles";

const SideBar = ({ setSidebarActive }) => {
  const [allAside, setAllAside] = useState({
    admin: false,
    language: false,
    career: false,
    functional: false,
    gender: false,
    industry: false,
    experience: false,
    skill: false,
    types: false,
    shifts: false,
    degreeLevel: false,
    degreeType: false,
    majorSub: false,
    resultType: false,
    maritalStatus: false,
    ownership: false,
    salaryPeriod: false,
    jobs: false,
    company: false,
    users: false,
    translate: false,
    cms: false,
    manageblog: false,
    seo: false,
    faqs: false,
    homepage: false,
    testimonial: false,
    slider: false,
    candidate: false,
    category: false,
    location: false,
    countries: false,
    countrydetails: false,
    state: false,
    cities: false,
    packages: false,
    resume: false,
    site: false,
    selectCandidate: false,
    position: false,
    currency: false,
    report: false,
    companyMaster: false,
    master: false
  });

  const changeOpen = (val, str) => {
    const clone = { ...allAside };
    for (const iterator in clone) {
      if (iterator == str) {
        clone[str] = val;
      } else {
        clone[iterator] = false;
      }
    }
    setAllAside(clone);
    setSidebarActive(true)
  };


  const [profileData, setProfileData] = useState(null)

  const profileDataGet = async () => {
    try {
      const res = await getProfileApi()
      console.log(res);
      setProfileData(res?.data)

    } catch (error) {

    }
  }

  useEffect(() => {
    profileDataGet()
  }, [])

  return (
    <>
      <div className="pageSidebar" style={{ height: "100%" }}>
        <ul className="mainList">
          <li className="navItem start active">
            <div className="text">
              <BiHomeAlt2 />
              <Link to="/admin" className="title">
                Dashboard
              </Link>
            </div>
          </li>

          {/* ---admin--user--- */}
          {profileData?.data?.role == 'admin' &&
            <li className="heading">
              <h3 className="uppercase">Users</h3>
            </li>}
          {profileData?.data?.role == 'admin' &&
            <li className="navItem">
              <button
                className={`navLink ${allAside.admin ? "active" : ""}`}
                onClick={() => {
                  changeOpen(!allAside.admin, "admin");
                }}
              >
                <div className="text">
                  <BiUser />
                  <span className="title">Users</span>
                </div>
                <div className="arrow">
                  <BiChevronLeft />
                </div>
              </button>
              {allAside.admin && (
                <ul className="subMenu">
                  <li className="subItem">
                    <Link to="list-admin-users" className="subLink">
                      <div className="subText">
                        <span className="title">List All Sub Users</span>
                      </div>
                    </Link>
                  </li>

                  <li className="subItem">
                    <Link to="create-admin-user" className="subLink">
                      <div className="subText">
                        <span className="title">Add Sub User</span>
                      </div>
                    </Link>
                  </li>
                </ul>
              )}
            </li>}


          {/* -----module--- */}
          {/* -----module--- */}
          {/* -----module--- */}
          <li className="heading">
            <h3 className="uppercase">modules</h3>
          </li>

          <li className="navItem">
            <button
              className={`navLink ${allAside.jobs ? "active" : ""}`}
              onClick={() => {
                changeOpen(!allAside.jobs, "jobs");
              }}
            >
              <div className="text">
                <BsBriefcase />
                <span className="title">jobs</span>
              </div>
              <div className="arrow">
                <BiChevronLeft />
              </div>
            </button>
            {allAside.jobs && (
              <ul className="subMenu">
                {/* <li className="subItem">
                  <NavLink to="list-jobs" className="subLink">
                    <div className="subText">
                      <span className="title">List jobs</span>
                    </div>
                  </NavLink>
                </li> */}
                <li className="subItem">
                  <NavLink to="create-classified-job" className="subLink">
                    <div className="subText">
                      <span className="title">Classified Job Post</span>
                    </div>
                  </NavLink>
                </li>
                <li className="subItem">
                  <NavLink to="list-jobs" className="subLink">
                    <div className="subText">
                      <span className="title">List jobs</span>
                    </div>
                  </NavLink>
                </li>
                <li className="subItem">
                  <NavLink to="create-job" className="subLink">
                    <div className="subText">
                      <span className="title">Add new jobs</span>
                    </div>
                  </NavLink>
                </li>
              </ul>
            )}
          </li>

          <li className="navItem">
            <button
              className={`navLink ${allAside.resume ? "active" : ""}`}
              onClick={() => {
                changeOpen(!allAside.resume, "resume");
              }}
            >
              <div className="text">
                <BsBriefcase />
                <span className="title">Manage Job</span>
              </div>
              <div className="arrow">
                <BiChevronLeft />
              </div>
            </button>
            {allAside.resume && (
              <ul className="subMenu">
                {/* <li className="subItem">
                  <NavLink to="list-resume" className="subLink">
                    <div className="subText">
                      <span className="title">List Resume</span>
                    </div>
                  </NavLink>
                </li> */}
                <li className="subItem">
                  <NavLink to="manage-job-responses" className="subLink">
                    <div className="subText">
                      <span className="title">Manage Job Responses</span>
                    </div>
                  </NavLink>
                </li>

              </ul>
            )}
          </li>



          {/* --company-- */}
          <li className="navItem">
            <button
              className={`navLink ${allAside.company ? "active" : ""}`}
              onClick={() => {
                changeOpen(!allAside.company, "company");
              }}
            >
              <div className="text">
                <BsBuildings />
                <span className="title">Companies</span>
              </div>
              <div className="arrow">
                <BiChevronLeft />
              </div>
            </button>
            {allAside.company && (
              <ul className="subMenu">
                <li className="subItem">
                  <NavLink to="list-companies" className="subLink">
                    <div className="subText">
                      <span className="title">List Companies</span>
                    </div>
                  </NavLink>
                </li>
                <li className="subItem">
                  <NavLink to="create-company" className="subLink">
                    <div className="subText">
                      <span className="title">Add new Company</span>
                    </div>
                  </NavLink>
                </li>

                <li className="subItem">
                  <NavLink to="list-payment-history" className="subLink">
                    <div className="subText">
                      <span className="title">
                        List Company Payment History
                      </span>
                    </div>
                  </NavLink>
                </li>
              </ul>
            )}
          </li>

          {/* ---candidates */}
          {/* ---candidates */}
          {profileData?.data?.role == 'admin' &&
            <li className="navItem">
              <button
                className={`navLink ${allAside.report ? "active" : ""}`}
                onClick={() => {
                  changeOpen(!allAside.report, "report");
                }}
              >
                <div className="text">
                  <BsBuildings />
                  <span className="title">Report</span>
                </div>
                <div className="arrow">
                  <BiChevronLeft />
                </div>
              </button>
              {allAside.report && (
                <ul className="subMenu">
                  <li className="subItem">
                    <NavLink to="list-login-history" className="subLink">
                      <div className="subText">
                        <span className="title">Login History</span>
                      </div>
                    </NavLink>
                  </li>
                  {profileData?.data?.role == 'admin' &&
                    <li className="subItem">
                      <NavLink to="user-report" className="subLink">
                        <div className="subText">
                          <span className="title">User Report</span>
                        </div>
                      </NavLink>
                    </li>
                  }
                  <li className="subItem">
                    <NavLink to="list-notification-history" className="subLink">
                      <div className="subText">
                        <span className="title">Notification History</span>
                      </div>
                    </NavLink>
                  </li>

                </ul>
              )}
            </li>}






          <li className="navItem">
            <button
              className={`navLink ${allAside.candidate ? "active" : ""}`}
              onClick={() => {
                changeOpen(!allAside.candidate, "candidate");
              }}
            >
              <div className="text">
                <CiUser />
                <span className="title">Candidates</span>
              </div>
              <div className="arrow">
                <BiChevronLeft />
              </div>
            </button>
            {allAside.candidate && (
              <ul className="subMenu">
                <li className="subItem">
                  <NavLink to="search-candidate" className="subLink">
                    <div className="subText">
                      <span className="title">Advance Search Candidates</span>
                    </div>
                  </NavLink>
                </li>
                <li className="subItem">
                  <NavLink to="candidate-list" className="subLink">
                    <div className="subText">
                      <span className="title">Candidates List</span>
                    </div>
                  </NavLink>
                </li>
                <li className="subItem">
                  <NavLink to="add-candidate" className="subLink">
                    <div className="subText">
                      <span className="title">Add Candidates</span>
                    </div>
                  </NavLink>
                </li>

                <li className="subItem">
                  <NavLink to="candidate-CVS" className="subLink">
                    <div className="subText">
                      <span className="title">Candidates CSV Import</span>
                    </div>
                  </NavLink>
                </li>

                <li className="subItem">
                  <NavLink to="candidate-CVS-list" className="subLink">
                    <div className="subText">
                      <span className="title">Candidates CSV Import List</span>
                    </div>
                  </NavLink>
                </li>
              </ul>
            )}
          </li>

          {/* ---selected--candidates */}
          <li className="navItem">
            <button
              className={`navLink ${allAside.selectCandidate ? "active" : ""}`}
              onClick={() => {
                changeOpen(!allAside.selectCandidate, "selectCandidate");
              }}
            >
              <div className="text">
                <FaUsers />
                <span className="title">Selected Candidates</span>
              </div>
              <div className="arrow">
                <BiChevronLeft />
              </div>
            </button>
            {allAside.selectCandidate && (
              <ul className="subMenu">
                <li className="subItem">
                  <NavLink to="selected-candidate" className="subLink">
                    <div className="subText">
                      <span className="title">Selected Candidate</span>
                    </div>
                  </NavLink>
                </li>
                <li className="subItem">
                  <NavLink to="selected-candidate-list" className="subLink">
                    <div className="subText">
                      <span className="title">Selected Candidate List</span>
                    </div>
                  </NavLink>
                </li>
              </ul>
            )}
          </li>



          {/* <li className="navItem">
            <button
              className={`navLink ${allAside.companyMaster ? "active" : ""}`}
              onClick={() => {
                changeOpen(!allAside.companyMaster, "companyMaster");
              }}
            >
              <div className="text">
                <BsBriefcase />
                <span className="title">Company Master</span>
              </div>
              <div className="arrow">
                <BiChevronLeft />
              </div>
            </button>
            {allAside.companyMaster && (
              <ul className="subMenu">
               
                <li className="subItem">
                  <NavLink to="add-company-master" className="subLink">
                    <div className="subText">
                      <span className="title">Add Company</span>
                    </div>
                  </NavLink>
                </li>
                <li className="subItem">
                  <NavLink to="list-company-master" className="subLink">
                    <div className="subText">
                      <span className="title">List Company</span>
                    </div>
                  </NavLink>
                </li>
              </ul>
            )}
          </li> */}
          {profileData?.data?.role == 'admin' &&
            <li className="navItem">
              <button
                className={`navLink ${allAside.master ? "active" : ""}`}
                onClick={() => {
                  changeOpen(!allAside.master, "master");
                }}
              >
                <div className="text">
                  <BsBriefcase />
                  <span className="title">Master</span>
                </div>
                <div className="arrow">
                  <BiChevronLeft />
                </div>
              </button>
              {allAside.master && (
                <ul className="subMenu">
                  {/* <li className="subItem">
                  <NavLink to="list-jobs" className="subLink">
                    <div className="subText">
                      <span className="title">List jobs</span>
                    </div>
                  </NavLink>
                </li> */}
                  <li className="subItem">
                    <NavLink to="list-admin-users" className="subLink">
                      <div className="subText">
                        <span className="title">Admin User</span>
                      </div>
                    </NavLink>
                  </li>
                  <li className="subItem">
                    <NavLink to="list-languages" className="subLink">
                      <div className="subText">
                        <span className="title">Language</span>
                      </div>
                    </NavLink>
                  </li>
                  <li className="subItem">
                    <NavLink to="list-countries" className="subLink">
                      <div className="subText">
                        <span className="title">Country</span>
                      </div>
                    </NavLink>
                  </li>
                  <li className="subItem">
                    <NavLink to="list-states" className="subLink">
                      <div className="subText">
                        <span className="title">State</span>
                      </div>
                    </NavLink>
                  </li>
                  {/* <li className="subItem">
                    <NavLink to="list-cities" className="subLink">
                      <div className="subText">
                        <span className="title">City</span>
                      </div>
                    </NavLink>
                  </li> */}
                  <li className="subItem">
                    <NavLink to="list-genders" className="subLink">
                      <div className="subText">
                        <span className="title">Gender</span>
                      </div>
                    </NavLink>
                  </li>
                  {/* <li className="subItem">
                    <NavLink to="list-currency" className="subLink">
                      <div className="subText">
                        <span className="title">Currency</span>
                      </div>
                    </NavLink>
                  </li> */}
                  <li className="subItem">
                    <NavLink to="category-list" className="subLink">
                      <div className="subText">
                        <span className="title">Job Category</span>
                      </div>
                    </NavLink>
                  </li>
                  <li className="subItem">
                    <NavLink to="location-list" className="subLink">
                      <div className="subText">
                        <span className="title">Location / City</span>
                      </div>
                    </NavLink>
                  </li>
                  <li className="subItem">
                    <NavLink to="list-job-skills" className="subLink">
                      <div className="subText">
                        <span className="title">Skills</span>
                      </div>
                    </NavLink>
                  </li>
                  <li className="subItem">
                    <NavLink to="list-industries" className="subLink">
                      <div className="subText">
                        <span className="title">Industry</span>
                      </div>
                    </NavLink>
                  </li>
                  <li className="subItem">
                    <NavLink to="list-ownership-types" className="subLink">
                      <div className="subText">
                        <span className="title">Ownership Types</span>
                      </div>
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>
          }

          {/* ----category--- */}
        </ul>
      </div>
    </>
  );
};

export default SideBar;
